<app-header></app-header>
<mat-card i18n *ngIf="!preinscripcio.potModificar">
    La preinscripció es troba en un estat de només lectura
</mat-card>
<mat-vertical-stepper [linear]="true" #stepper> 
    <mat-step [completed]="step1component.isValid() && dataService.stepPerformed(1)">
        <ng-template matStepLabel i18n>Dades personals</ng-template>
        <app-dades-personals #step1component [stepper]="stepper"></app-dades-personals>
    </mat-step>
    <mat-step [completed]="step2component.isValid() && dataService.stepPerformed(2)">
        <ng-template matStepLabel i18n>Dades de contacte</ng-template>
        <app-dades-contacte #step2component [stepper]="stepper"></app-dades-contacte>
    </mat-step>                
    <mat-step [completed]="step3component.isValid() && dataService.stepPerformed(3)">
        <ng-template matStepLabel i18n>Estudis</ng-template>
        <app-estudis #step3component [stepper]="stepper"></app-estudis>
    </mat-step>
    <mat-step [completed]="step4component.isValid() && dataService.stepPerformed(4)">
        <ng-template matStepLabel i18n>Idiomes</ng-template>
        <app-idiomes #step4component [stepper]="stepper"></app-idiomes>
    </mat-step>
    <mat-step [completed]="step5component.isValid() && dataService.stepPerformed(5)">
        <ng-template matStepLabel i18n>Informació addicional</ng-template>
        <app-altres #step5component [stepper]="stepper"></app-altres>
    </mat-step>                                
    <mat-step [completed]="step6component.isValid() && dataService.stepPerformed(6)">
        <ng-template matStepLabel i18n>Documentació</ng-template>
        <app-documentacio #step6component [stepper]="stepper"></app-documentacio>
    </mat-step>                        
    <mat-step [completed]="step7component.isValid() && dataService.stepPerformed(7)" *ngIf="dataService.preinscripcio.oferta.pagaInscripcio">
        <ng-template matStepLabel i18n>Pagament</ng-template>
        <app-pagament #step7component [stepper]="stepper"></app-pagament>
    </mat-step>
    <mat-step [completed]="step8component.isValid() && dataService.stepPerformed(8)" *ngIf="(!dataService.preinscripcio.isnew) && (dataService.preinscripcio.estat!=64)">
        <ng-template matStepLabel i18n>Estat de la preinscripció</ng-template>
        <app-confirmacio #step8component></app-confirmacio>
    </mat-step>
</mat-vertical-stepper>


// WEBPACK FOOTER //
// ./src/app/preinscripcio/preinscripcio.component.html